import CityServicePage from "@/pages/city-service/CityServicePage";
import { mississaugaBoiler } from "@/mocks/cityServiceData";
export default function Page() { return <CityServicePage config={mississaugaBoiler} />; }
